import { Grid } from '@mui/material';
import FinanceListGrid from './financeListGrid.view';
import AddEditFinancialRecordView from './addEditFinancialRecord.view';

const FinanceList = () => {
  return (
    <Grid container spacing={{ xs: 1, sm: 2 }} data-testid="finance-list-container" sx={{ height: '100%' }}>
      <Grid item xs={12}>
        <FinanceListGrid />
      </Grid>
      <AddEditFinancialRecordView />
    </Grid>
  );
};

export default FinanceList;
